import { render, staticRenderFns } from "./AllShipmentRequest.vue?vue&type=template&id=71710dd6"
import script from "./AllShipmentRequest.vue?vue&type=script&lang=js"
export * from "./AllShipmentRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports